<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "tag" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 17 16'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M5.83301 5.3335H5.83968M1.83301 3.46683L1.83301 6.44984C1.83301 6.77596 1.83301 6.93902 1.86985 7.09247C1.90251 7.22852 1.95638 7.35858 2.02949 7.47787C2.11194 7.61243 2.22724 7.72773 2.45785 7.95833L7.57027 13.0708C8.3623 13.8628 8.75832 14.2588 9.21497 14.4072C9.61666 14.5377 10.0494 14.5377 10.451 14.4072C10.9077 14.2588 11.3037 13.8628 12.0958 13.0708L13.5703 11.5962C14.3623 10.8042 14.7583 10.4082 14.9067 9.95153C15.0372 9.54984 15.0372 9.11715 14.9067 8.71546C14.7583 8.2588 14.3623 7.86279 13.5703 7.07075L8.45785 1.95833C8.22724 1.72773 8.11194 1.61243 7.97739 1.52998C7.85809 1.45687 7.72803 1.403 7.59198 1.37034C7.43853 1.3335 7.27547 1.3335 6.94935 1.3335L3.96634 1.3335C3.2196 1.3335 2.84624 1.3335 2.56102 1.47882C2.31014 1.60665 2.10616 1.81063 1.97833 2.06151C1.83301 2.34672 1.83301 2.72009 1.83301 3.46683ZM6.16634 5.3335C6.16634 5.51759 6.0171 5.66683 5.83301 5.66683C5.64891 5.66683 5.49968 5.51759 5.49968 5.3335C5.49968 5.1494 5.64891 5.00016 5.83301 5.00016C6.0171 5.00016 6.16634 5.1494 6.16634 5.3335Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>